export default __webpack_public_path__ + "static/ti_motorhome_pink-730740423ae5246e28220ec7d2ae282b.svg";